class TwoPmComparison extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.scrollArea = this.querySelector('[data-comparison-scroll]');
    this.previousButton = this.querySelector('[data-comparison-previous]');
    this.nextButton = this.querySelector('[data-comparison-next]');

    if (!this.scrollArea || !this.previousButton || !this.nextButton) return;

    this.initialized = true;
    this.handleScroll = this.updateNavigation.bind(this);
    this.handleResize = this.updateNavigation.bind(this);
    this.handlePrevious = () => this.scrollByColumn(-1);
    this.handleNext = () => this.scrollByColumn(1);

    this.previousButton.addEventListener('click', this.handlePrevious);
    this.nextButton.addEventListener('click', this.handleNext);
    this.scrollArea.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);

    this.updateNavigation();
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.scrollArea.removeEventListener('scroll', this.handleScroll);
    this.previousButton.removeEventListener('click', this.handlePrevious);
    this.nextButton.removeEventListener('click', this.handleNext);
    window.removeEventListener('resize', this.handleResize);
    this.initialized = false;
  }

  scrollByColumn(direction) {
    const column = this.querySelector('.two-pm-comparison__competitor-column');
    const distance = column ? column.getBoundingClientRect().width : 150;

    this.scrollArea.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  updateNavigation() {
    const maximumScroll = this.scrollArea.scrollWidth - this.scrollArea.clientWidth;
    const canScroll = maximumScroll > 1;

    this.previousButton.disabled = !canScroll || this.scrollArea.scrollLeft <= 1;
    this.nextButton.disabled = !canScroll || this.scrollArea.scrollLeft >= maximumScroll - 1;
  }
}

if (!customElements.get('two-pm-comparison')) {
  customElements.define('two-pm-comparison', TwoPmComparison);
}
